import {Switch} from '@wandb/weave/components';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React from 'react';

import {BoldLabel, ErrorText, SmallText} from './shared';

export type RunFilter = {
  limitToMyRuns: boolean;
  isRunNameFilterEnabled: boolean;
  runName?: string;
  username: string;
};

export type RunFilterConfig = Partial<RunFilter> &
  Pick<RunFilter, 'isRunNameFilterEnabled'>;

export const RunFilterChunk = ({
  runFilter,
  setRunName,
  setIsRunNameFilterEnabled,
}: {
  runFilter: RunFilterConfig;
  setRunName: (runName: string) => void;
  setIsRunNameFilterEnabled: (isRunNameFilterEnabled: boolean) => void;
}) => {
  const showRunNameError =
    runFilter.isRunNameFilterEnabled &&
    runFilter.runName !== undefined &&
    !isValidRunName(runFilter.isRunNameFilterEnabled, runFilter.runName);
  return (
    <>
      <div className="flex flex-row">
        <div className="flex-1">
          <BoldLabel>Filter on run name</BoldLabel>
          <SmallText>
            {/* yes, requested ux text is to use the word "trigger" here */}
            Trigger this event only on runs whose name contains the following
            regex string.
          </SmallText>
        </div>
        <div className="flex-0">
          <Switch.Root
            size="medium"
            checked={runFilter.isRunNameFilterEnabled}
            onCheckedChange={isChecked => setIsRunNameFilterEnabled(isChecked)}>
            <Switch.Thumb
              size="medium"
              checked={runFilter.isRunNameFilterEnabled}
            />
          </Switch.Root>
        </div>
      </div>
      <div className="mt-8">
        <TextField
          value={
            runFilter.isRunNameFilterEnabled ? runFilter.runName || '' : ''
          }
          onChange={value => setRunName(value)}
          placeholder="Ex. run-name-.*"
          disabled={!runFilter.isRunNameFilterEnabled}
        />
        {showRunNameError && (
          <ErrorText>Run name cannot be empty if specified</ErrorText>
        )}
      </div>
    </>
  );
};

export const isValidRunName = (
  isRunNameFilterEnabled: boolean,
  runName: string | undefined
) => {
  return !isRunNameFilterEnabled || (runName !== undefined && runName !== '');
};

export const getRunMetricRunFilterString = (runFilter: Partial<RunFilter>) => {
  const rawStr = getRunFilterString(runFilter);
  if (rawStr.length > 0) {
    return `runs ${rawStr} have an `;
  }
  return '';
};

export const getRunFilterString = (runFilter: Partial<RunFilter>) => {
  const runNameSnippet = runFilter.isRunNameFilterEnabled
    ? `matching "${runFilter.runName}"`
    : '';
  const myRunsSnippet = runFilter.limitToMyRuns ? `by me` : '';
  if (runNameSnippet.length > 0 || myRunsSnippet.length > 0) {
    return [runNameSnippet, myRunsSnippet].filter(s => s.length > 0).join(' ');
  }
  return '';
};

export const getRunFilterConfigFromTriggerFilter = (
  parsedFilter: any
): RunFilterConfig | undefined => {
  const runFilterRaw = JSON.parse(parsedFilter.run_filter);

  if (!runFilterRaw) {
    return undefined;
  }

  // Convert the mongo filter back to our RunFilter type
  const runNameFilter = runFilterRaw.$and?.find(
    (f: any) => f?.displayName?.$regex != null
  );
  const usernameFilter = runFilterRaw.$and?.find(
    (f: any) => f?.username?.$eq != null
  );

  const runFilter: RunFilterConfig = {
    isRunNameFilterEnabled: runNameFilter != null,
    runName: runNameFilter?.displayName?.$regex,
    limitToMyRuns: usernameFilter != null,
    username: usernameFilter?.username?.$eq,
  };

  return runFilter;
};
